import type { PartialMessageProps } from '@zg-rentals/backend-styled-components';

type DefaultErrorDataType = { messageCode?: string; partialMessages?: Array<PartialMessageProps> };

const ErrorRMW = <T = DefaultErrorDataType>({
  code = '',
  message = '',
  // could be anything
  data = {} as T,
  httpStatus = '',
}: { code?: string; message?: string; data?: T; httpStatus?: string } = {}) => ({
  code: String(code),
  message: String(message),
  data,
  httpStatus: String(httpStatus),
});

export default ErrorRMW;

export type ErrorRMWProps<T = DefaultErrorDataType> = ReturnType<typeof ErrorRMW<T>>;
